import { useContext } from "react";

import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";

import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

export const StepChanger = ({
  steps,
  activeStep,
  setActiveStep,
  order,
  shipmentOne,
  shipmentTwo,
  addressConfirmed,
}) => {
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const handleNext = () => {
    if (activeStep === 0) {
      if (staffCheck()) {
        setActiveStep((prev) => prev + 1);
      }
    } else if (activeStep === 1) {
      if (postCodeCheck()) {
        setActiveStep((prev) => prev + 1);
      }
    } else if (activeStep === 2) {
      if (shippingServiceCheck()) {
        setActiveStep((prev) => prev + 1);
      }
    } else {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prev) => prev - 1);
  };

  const staffCheck = () => {
    const staff = order?.data?.staff || [];
    if (!staff.length) {
      setAlertNotification({
        message: "Please add a staff member to the order",
        severity: "warning",
      });
      return false;
    }
    if (!staffItemsCheck(staff)) {
      setAlertNotification({
        message: "Please add some items to continue",
        severity: "warning",
      });
      return false;
    }
    if (!staffBlockedCheck(staff)) {
      setAlertNotification({
        message: "The selected staff member is blocked",
        severity: "warning",
      });
      return false;
    }
    if (!staffContractBlockedCheck(staff)) {
      setAlertNotification({
        message: "The selected staff member has a blocked contract",
        severity: "warning",
      });
      return false;
    }
    return true;
  };

  const staffItemsCheck = (staff) =>
    staff.every((person) => Number(person.numberOfLines) > 0);

  const staffBlockedCheck = (staff) =>
    staff.every((person) => person.blocked !== "Yes");

  const staffContractBlockedCheck = (staff) =>
    staff.every((person) => person.contractBlocked !== "Yes");

  const hasShippingSelection = (shipment) => {
    if (!shipment || !shipment.shipping) return false;
    const index = shipment.shipping.index;
    return index !== "" && index !== null && index !== undefined;
  };

  const shippingServiceCheck = () => {
    if (!hasShippingSelection(shipmentOne)) {
      setAlertNotification({
        message: "Please select a shipping service",
        severity: "warning",
      });
      return false;
    }
    if (shipmentTwo?.lines?.length > 0 && !hasShippingSelection(shipmentTwo)) {
      setAlertNotification({
        message: "Please select a shipping service",
        severity: "warning",
      });
      return false;
    }
    return true;
  };

  const postCodeCheck = () => {
    const postcode = order?.data?.order?.postCode?.replace(/\s/g, "") || "";
    if (!postcode) return true;
    const bannedPostcodes = ["B504HF", "N227DE"];
    if (bannedPostcodes.includes(postcode.toUpperCase())) {
      setAlertNotification({
        message: "We cannot deliver to this postcode",
        severity: "warning",
      });
      return false;
    }
    return true;
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "row", pt: 2, pb: 1 }}>
      {activeStep <= 3 && (
        <Button
          color="inherit"
          disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ mr: 1 }}
        >
          Back
        </Button>
      )}
      <Box sx={{ flex: "1 1 auto" }} />
      {activeStep <= 2 && (
        <Button
          onClick={handleNext}
          disabled={
            !order?.data?.order?.no ||
            (activeStep === 1 && addressConfirmed === false)
          }
        >
          {activeStep === steps.length - 1 ? "Submit Order" : "Next"}
        </Button>
      )}
    </Box>
  );
};
